// extracted by mini-css-extract-plugin
module.exports = {"menu":"AnimatedMenu_menu__eRQPm","menu__item":"AnimatedMenu_menu__item__YGUIT"};